<template>
  <div class="w-100 d-flex align-items-center">
    <div class="pr-0 text-right">
      <b-button
        :id="tourKeyword"
        variant="flat-secondary"
        style="width: 86px;"
        class="p-1"
        @click="callback ? $emit('back') : routeName ? $router.replace({ name: routeName, params, queries }) : $router.go(-1)"
      >
        <feather-icon
          icon="ArrowLeftIcon"
          size="15"
        />
        {{ $t('Back') }}
      </b-button>
    </div>

    <div class="w-100 pl-1 border-left border-2">
      <div
        class="d-flex align-items-start"
        style="max-width: calc(100% - 72px)"
      >
        <h4
          v-b-tooltip.hover="title"
          class="mb-0 text-truncate"
        >
          {{ title }}
        </h4>

        <slot
          style="min-width: 120px;"
          name="append"
        />
      </div>

      <small
        v-if="description"
        class="text-muted"
      >{{ description }}</small>
    </div>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'

export default {
  components: {
    BButton,
  },
  props: {
    title: {
      type: String,
      default: () => '',
    },
    description: {
      type: String,
      default: () => null,
    },
    routeName: {
      type: String,
      default: () => null,
    },
    params: {
      type: Object,
      default: () => {},
    },
    queries: {
      type: Object,
      default: () => {},
    },
    callback: {
      type: Boolean,
      default: () => false,
    },
    tourKeyword: {
      type: String,
      default: () => null,
    },
  },
}
</script>
